import { useContext } from "react";
import { AppContext } from '../../context.js';

function PhysicianAvatar(props) {
    const { id, src, className, style, onClick } = props;
    const context = useContext(AppContext);

    if (src) {
        return (
            <img className={"avatar " + className} onClick={onClick} src={'/api/admin/files/' + src + '?token='+context.token} style={style} alt="Avatar" />
        );
    }

    return (
        <img className={"avatar " + className} onClick={onClick} src={'/api/admin/physicians/profileImage/' + id + '?token='+context.token} style={style} alt="Avatar" />
    );
}

function PatientAvatar(props) {
    const { id, src, className, style, onClick } = props;
    const context = useContext(AppContext);

    if (src) {
        return (
            <img className={"avatar " + className} onClick={onClick} src={'/api/admin/files/' + src + '?token='+context.token} style={style} alt="Avatar" />
        );
    }

    return (
        <img className={"avatar " + className} onClick={onClick} src={'/api/admin/patients/profileImage/' + id + '?token='+context.token} style={style} alt="Avatar" />
    );
}

function Button(props) {
    const { onClick, color, muted, size, text, className, leftIcon, rightIcon, style, disabled } = props;
    return (
        <button
            onClick={disabled ? undefined : onClick}
            disabled={disabled}
            className={"button " + color + " " + (muted ? "muted" : "") + " " + size + " typo-body-medium " + className + (disabled ? " disabled" : "")}
        >
            {leftIcon}
            {text}
            {rightIcon}
        </button>
    );
}

function Status(props) {
    const { color, muted, size, text, subtext, freetext, className, leftIcon, rightIcon } = props;
    return (
        <div className={"status " + color + " " + (muted ? "muted" : "") + " " + size + " " + className}>
            {leftIcon}
            {text && (
                <span className="typo-body-medium">{text}</span>
            )}
            {subtext && (
                <span className="typo-body-small">{subtext}</span>
            )}
            {freetext && (
                <span>{freetext}</span>
            )}
            {rightIcon}
        </div>
    );
}

function Counter(props) {
    const { color, muted, size, text, className } = props;
    return (
        <div className={"counter " + color + " " + (muted ? "muted" : "") + " " + size + " typo-body-small " + className}>
            {text}
        </div>
    );
}

function Input(props) {
    const { value, placeholder, onChange, size, text, className } = props;
    return (
        <input type="text" value={value} placeholder={placeholder} onChange={onChange} className={"input " + size + " typo-body-medium " + className} />
    );
}

function Section({ title, children }) {
  return (
    <div className="mb-4">
      <div className="typo-strong-200 mb-2 border-b border-neutral-200 pb-1">
        {title}
      </div>
      {children}
    </div>
  );
}

function Field({
    label,
    value,
    onChange,
    type = "text",
    required,
    options,
    hint,
    placeholder,
    disabled,
    hideDefaults,
    error,
  }) {
    if (disabled && hideDefaults) return null;
    const handleChange = (val) => {
      if (disabled) return;
      if (onChange) onChange(val);
    };
    const isMissing = required && !disabled && !String(value ?? "").trim();
    const controlClassName = [
      "input md typo-body-medium w-full",
      disabled &&
        "bg-neutral-100 text-neutral-400 border-neutral-200 cursor-not-allowed select-none",
      (isMissing || error) && "border-red-500 bg-red-50",
    ]
      .filter(Boolean)
      .join(" ");
    return (
      <div className="mb-3">
        <div className="typo-strong-125">
          {label}
          {required && <span className="text-red-600"> *</span>}
        </div>
        {options ? (
          <select
            value={value || ""}
            onChange={(e) => handleChange(e.target.value)}
            disabled={disabled}
            className={controlClassName}
          >
            {options.map((opt) => {
              const { value: optValue, label: optLabel } =
                typeof opt === "string" ? { value: opt, label: opt } : opt;
              return (
                <option key={optValue} value={optValue}>
                  {optLabel}
                </option>
              );
            })}
          </select>
        ) : (
          <input
            type={type}
            value={value || ""}
            placeholder={placeholder || (disabled && !value ? "Blank" : "")}
            onChange={(e) => handleChange(e.target.value)}
            disabled={disabled}
            className={controlClassName}
          />
        )}
        {hint && <div className="typo-normal-125 text-muted mt-1">{hint}</div>}
      </div>
    );
}

export { PhysicianAvatar, PatientAvatar, Button, Status, Counter, Input, Section, Field };